import { mapActions, mapGetters, mapState } from "vuex";
import {
  POST_STATUS,
  POST_BY_FACILITY_STATUS,
  POSTS_CALL_TO_ACTION_TYPE,
  POSTS_FORM_TYPE,
  POSTS_REPORT_INSIGHTS
} from "@/enums/posts.enum";
import { FORMAT } from "@/config/date-format";
import moment from "moment";
import { FEATURE_FLAG } from "@/helpers/posthog";

export const plannedPostItemMixin = {
  props: {
    post: {
      type: Object,
      default: () => {}
    },
    gmbInsights: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      POST_BY_FACILITY_STATUS,
      POSTS_REPORT_INSIGHTS,
      FEATURE_FLAG,
      iconSize: 18,
      dialog: { deletePost: false, facilitiesList: false },
      chosenSendingStatus: null
    };
  },
  computed: {
    ...mapGetters({
      hasStoreLocator: "company/hasStoreLocator"
    }),
    hasImage() {
      return this.post && this.post.post_data && this.post.post_data.image_url;
    },
    hasInsightsData() {
      return (
        this.post &&
        moment(this.post.created_at).isSameOrBefore(
          moment({ month: 1, year: 2023 }).endOf("month")
        ) &&
        this.gmbInsights &&
        Object.values(POSTS_REPORT_INSIGHTS).every(
          key => key in this.gmbInsights
        )
      );
    },
    durationTime() {
      if (
        this.post &&
        this.post.post_data &&
        this.post.post_data.event &&
        this.post.post_data.event.schedule
      ) {
        const fromDate = this.post.post_data.event.schedule.start_date
          ? moment({
              ...this.post.post_data.event.schedule.start_date,
              month: this.post.post_data.event.schedule.start_date.month - 1
            }).format(FORMAT.DATE)
          : "";
        const fromTime = this.post.post_data.event.schedule.start_time
          ? moment(this.post.post_data.event.schedule.start_time).format(
              FORMAT.HM
            )
          : "";

        const toDate = this.post.post_data.event.schedule.end_date
          ? moment({
              ...this.post.post_data.event.schedule.end_date,
              month: this.post.post_data.event.schedule.end_date.month - 1
            }).format(FORMAT.DATE)
          : "";
        const toTime = this.post.post_data.event.schedule.end_time
          ? moment(this.post.post_data.event.schedule.end_time).format(
              FORMAT.HM
            )
          : "";

        return {
          from: `${fromDate} ${fromTime}`,
          to: `${toDate} ${toTime}`
        };
      }
      return null;
    },
    categoryName() {
      return this.$t(
        `message.posts.list.${this.post &&
          this.post.post_data &&
          this.post.post_data.type}`
      );
    },
    postType() {
      if (!this.post || !this.post.post_data || !this.post.post_data.type)
        return null;

      const type = Object.keys(POSTS_FORM_TYPE).find(
        key => POSTS_FORM_TYPE[key] === this.post.post_data.type
      );
      return type ? type.toLowerCase() : null;
    },
    isProcessing() {
      return (
        this.post &&
        this.post.status &&
        this.post.status === POST_STATUS.PENDING
      );
    },
    isFinished() {
      return (
        this.post &&
        this.post.status &&
        (this.post.status === POST_STATUS.COMPLETED ||
          this.post.status === POST_STATUS.FINISHED_WITH_PROBLEMS)
      );
    },
    isDeleted() {
      return this.post && this.post.is_deleted;
    }
  }
};
